import { useAuthStore } from '@/stores/retailer/auth.js'

export default function retailerForwardSaleBlocker(to, from, next) {
  const authStore = useAuthStore()

  if (authStore.isDemo) {
    next()
    return
  }

  if (authStore.forwardSalesChannelStatus || authStore.virtualPosSalesChannelStatus) {
    next()
    return
  }

  next({
    name: 'retailer.information'
  })
}
